import { createFeatureSelector, createSelector } from '@ngrx/store';

import { OrderAnalysicModel } from '@app/models/myoffice/order/order-analysic.model';
import { orderAnalysisFeatureKey } from '@app/reducers/myoffice/order/order-analysis.reducer';

export interface OrderAnalysisState {
  itemsByRank: OrderAnalysicModel[];
  itemsByAge: OrderAnalysicModel[];
  itemByMonth:OrderAnalysicModel;
  itemsByCate: OrderAnalysicModel[];
  itemsByProduct: OrderAnalysicModel[];
}

export const getOrderAnalysisState= createFeatureSelector<OrderAnalysisState>(orderAnalysisFeatureKey);


export const getOrderAnalysisByRank = createSelector(
  getOrderAnalysisState,
  (state: OrderAnalysisState) => state.itemsByRank
);
export const getOrderAnalysisByAge = createSelector(
  getOrderAnalysisState,
  (state: OrderAnalysisState) => state.itemsByAge
);

export const getOrderAnalysisByMonth = createSelector(
  getOrderAnalysisState,
  (state: OrderAnalysisState) => state.itemByMonth
);

export const getOrderAnalysisByCate = createSelector(
  getOrderAnalysisState,
  (state: OrderAnalysisState) => state.itemsByCate
);

export const getOrderAnalysisByProduct = createSelector(
  getOrderAnalysisState,
  (state: OrderAnalysisState) => state.itemsByProduct
);